module.exports = __webpack_public_path__ + "media/images/athletes/551-57300a00949992997154c927c0a1e28c.png";